// What the website writes when a header text is left empty: its own translated defaults
// (sunsky-website src/i18n/locales/{nl,en}/common.json, `nav.*`). The editor shows them as
// placeholders and the live preview draws them, so an empty field reads as what visitors see.
// Keep in step with the website's translation files.

export const LANGS = ['nl', 'en'];

export const WEBSITE_DEFAULTS = {
  destinationsLabel: { nl: 'Populaire bestemmingen', en: 'Popular destinations' }, // nav.popularDestinations
  holidayTypesLabel: { nl: 'Vakantietypes', en: 'Holiday types' }, // nav.holidayTypes
  exploreHolidays: { nl: 'Ontdek vakanties', en: 'Explore holidays' }, // nav.exploreHolidays
  searchPlaceholder: { nl: 'Zoek bestemming, hotel of regio', en: 'Search destination, hotel or region' }, // nav.searchPlaceholder
  customerService: { nl: 'Klantendienst', en: 'Customer service' }, // nav.customerService
  signIn: { nl: 'Inloggen', en: 'Sign In' }, // nav.signIn
  register: { nl: 'Registreren', en: 'Register' }, // nav.register
  myAccount: { nl: 'Mijn account', en: 'My Account' }, // nav.myAccount
  signOut: { nl: 'Uitloggen', en: 'Sign Out' }, // nav.signOut
  seeAll: { nl: 'Alles bekijken', en: 'See all' }, // nav.seeAll (new key)
  menu: { nl: 'Menu', en: 'Menu' }, // nav.menu
};

// nav.myBookings / nav.profile / nav.favourites
export const ACCOUNT_MENU_DEFAULTS = {
  bookings: { nl: 'Mijn boekingen', en: 'My Bookings' },
  profile: { nl: 'Profiel', en: 'Profile' },
  favourites: { nl: 'Favorieten', en: 'Favourites' },
};

// nav.services.<key>
export const SERVICE_DEFAULTS = {
  holidays: { nl: 'Vakanties', en: 'Holidays' },
  flights: { nl: 'Vluchten', en: 'Flights' },
  hotels: { nl: 'Hotels', en: 'Hotels' },
  transfers: { nl: 'Transfers', en: 'Transfers' },
};

// The panel's count line ("7 destinations"), per menu kind.
export const TALLY_NOUNS = {
  destinations: { nl: ['bestemming', 'bestemmingen'], en: ['destination', 'destinations'] },
  holidayTypes: { nl: ['vakantietype', 'vakantietypes'], en: ['holiday type', 'holiday types'] },
  custom: { nl: ['link', 'links'], en: ['link', 'links'] },
};

export const tally = (kind, count, lang) => {
  const [one, many] = TALLY_NOUNS[kind]?.[lang] || TALLY_NOUNS.custom.en;
  return `${count} ${count === 1 ? one : many}`;
};

/**
 * The website's text rule: the visitor's language when it has text; otherwise the fallback
 * when there is one (a website default, or a holiday type's name); otherwise the other
 * language; otherwise nothing.
 *
 * `fallback` may be a string or a { nl, en } pair.
 */
export function pickText(text, lang, fallback) {
  const own = String(text?.[lang] ?? '').trim();
  if (own) return own;
  if (fallback != null) {
    const fb = typeof fallback === 'string' ? fallback : String(fallback?.[lang] ?? '');
    if (fb.trim()) return fb.trim();
  }
  const other = String(text?.[lang === 'nl' ? 'en' : 'nl'] ?? '').trim();
  return other;
}

// The announcement strip's colours. The website owns the final look; these keep the preview
// honest about which tone is which.
export const ANNOUNCEMENT_TONE_STYLES = {
  orange: { label: 'Orange', background: 'linear-gradient(90deg, #f5a51e, #f7b54a)', color: '#ffffff' },
  blue: { label: 'Blue', background: '#2563eb', color: '#ffffff' },
  dark: { label: 'Dark', background: '#0f172a', color: '#ffffff' },
  green: { label: 'Green', background: '#16a34a', color: '#ffffff' },
};

export const SHOW_ON_LABELS = {
  all: 'All devices',
  desktop: 'Desktop only',
  mobile: 'Mobile only',
};
